import Head from "next/head";
const GlobalStyle = () => {
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="GlobalStyle.tsx">
        <style>
          {`
            body {
              overflow: hidden;
            }
          `}
        </style>
      </Head>
    </>;
};
export default GlobalStyle;